import {
  SoopLayer,
  SoopLayerHeader,
  SoopLayerContent,
  SoopLayerFooter,
  useDialogContext,
} from '@soop-ui/soop-ui';
import {useNavigate} from 'react-router-dom';
import {ROUTE} from '@/constants/main/route';
import {FormType} from '@/components/help/common/FormContainer/types';
import {FORM_TYPE_INQUIRY, FORM_TYPE_OBJECTION} from '@/constants/help/form';

interface FormSubmitSuccessDialogProps {
  type?: FormType;
  userId?: string;
}

const FormSubmitSuccessDialog = ({
  type = FORM_TYPE_INQUIRY,
  userId,
}: FormSubmitSuccessDialogProps) => {
  const {close} = useDialogContext();
  const navigate = useNavigate();

  // 레이어 헤더에 표시될 텍스트
  const headerText =
    type === FORM_TYPE_INQUIRY || type === FORM_TYPE_OBJECTION
      ? '문의'
      : '신고';

  const handleClose = () => {
    close(true);
    if (userId) {
      navigate(ROUTE.HELP.MY_INQUIRY);
    } else {
      navigate(ROUTE.HELP.INDEX);
    }
  };

  return (
    <SoopLayer size='lg' hideCloseButton={true}>
      <SoopLayerHeader align='center'>{`${headerText}완료`}</SoopLayerHeader>
      <SoopLayerContent>
        <p>
          문의는 순차적으로 처리되어 기간이 다소 소요될 수 있는 점 <br />
          양해 부탁드리며, 등록하신 내용은 성심껏 답변 드릴 수 <br />
          있도록 하겠습니다.
        </p>
      </SoopLayerContent>
      <SoopLayerFooter
        align='center'
        primaryLabel='확인'
        buttonVariant='defaultPrimary'
        onPrimaryClick={handleClose}
      />
    </SoopLayer>
  );
};

export default FormSubmitSuccessDialog;
